import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ServerCall from "../../serverCall";
import toast from "react-hot-toast";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  width: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const SubscriptionModal = ({ open, handleClose, userId }) => {
  const serverCall = ServerCall();
  const [loading, setLoading] = useState(false);
  const [stripeData, setStripeData] = useState({});

  const getStripeProduct = async () => {
    const response = await serverCall.customAxios.get("/get-stripe-product", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    setStripeData(response?.data);
  };

  const handleSubscribe = async () => {
    const raw = {
      plan: "silver",
      price: stripeData?.price?.unit_amount / 100,
      userId: userId,
    };
    setLoading(true);
    try {
      const response = await serverCall.customAxios.post(
        "/subscriptions-session",
        raw,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response.data);
      const sessionUrl = response.data.subscriptionSession;
      console.log(sessionUrl, "sessionUrl");
      // Redirect to the sessionUrl
      window.location.href = sessionUrl;
      // handleClose(); // Close the modal after successful subscription
    } catch (error) {
      console.error(error);
      toast.error("Failed to Subscribe Plan...");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getStripeProduct();
  }, []);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          gutterBottom
        >
          Subscription Plan
        </Typography>
        <Typography id="modal-modal-description" variant="body1" gutterBottom>
          Unlimited Valuations Subscription
        </Typography>
        <Typography variant="h4" component="h3" sx={{ mt: 3, mb: 2 }}>
          ${stripeData?.price?.unit_amount / 100 || "..."} per year
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubscribe}
          fullWidth
        >
          {loading ? "Redirecting" : "Subscribe Now"}
        </Button>
        <Typography
          className="flex align-center"
          variant="body2"
          color="textSecondary"
          sx={{ mt: 2 }}
        >
          <MonetizationOnIcon sx={{ fontSize: 16 }} className="mr-1" />
          {stripeData?.price?.unit_amount / 100 || "..."} Unlimited valuations
          included
        </Typography>
      </Box>
    </Modal>
  );
};

export default SubscriptionModal;
